'use strict';
/* eslint-disable */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _featureSupport = require('../constants/featureSupport');

var _installerErrors = require('./installerErrors');

var installerErrors = _interopRequireWildcard(_installerErrors);

var _getDependencyVersion = require('./getDependencyVersion');

var _getDependencyVersion2 = _interopRequireDefault(_getDependencyVersion);

var _stashedServiceWorkerVersion = require('./stashedServiceWorkerVersion');

var _defer = require('q/js/lib/defer');

var _defer2 = _interopRequireDefault(_defer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function validateRequiredInstallerOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var hasRequiredOpts = true;

  Object.keys(options).forEach(function (key) {
    var option = options[key];
    if (!option || option === null) {
      console.error(key + ' is required for making a new service worker installer.');
      hasRequiredOpts = false;
    }
  });

  return hasRequiredOpts;
}

function invalidInstaller() {
  var deferred = (0, _defer2.default)();
  deferred.reject(installerErrors.INVALID);
  return deferred.promise;
}

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$dependencyName = _ref.dependencyName,
      dependencyName = _ref$dependencyName === undefined ? null : _ref$dependencyName,
      _ref$dependencyVersio = _ref.dependencyVersion,
      dependencyVersion = _ref$dependencyVersio === undefined ? null : _ref$dependencyVersio,
      _ref$bundle = _ref.bundle,
      bundle = _ref$bundle === undefined ? null : _ref$bundle,
      _ref$scope = _ref.scope,
      scope = _ref$scope === undefined ? null : _ref$scope;

  var hasRequiredOpts = validateRequiredInstallerOptions({
    dependencyName: dependencyName,
    bundle: bundle,
    scope: scope
  });
  if (!hasRequiredOpts) return invalidInstaller;

  var currentVersion = dependencyVersion || (0, _getDependencyVersion2.default)(dependencyName);
  var stashedVersion = (0, _stashedServiceWorkerVersion.getStashedVersion)(dependencyName);
  var workerHasUpdated = currentVersion > stashedVersion;
  var installInProgress = false;

  return function () {
    var deferred = (0, _defer2.default)();

    if (!_featureSupport.HAS_SERVICE_WORKER_SUPPORT || installInProgress) {
      if (!_featureSupport.HAS_SERVICE_WORKER_SUPPORT) {
        deferred.reject(installerErrors.UNSUPPORTED);
      } else {
        deferred.reject(installerErrors.INSTALLING);
      }
    } else {
      if (workerHasUpdated || !stashedVersion) {
        installInProgress = true;
        navigator.serviceWorker.register(bundle, { scope: scope }).then(function () {
          (0, _stashedServiceWorkerVersion.setStashedVersion)(dependencyName, currentVersion);
          installInProgress = false;
          deferred.resolve(true);
        }).catch(function (error) {
          installInProgress = false;
          deferred.reject(error);
        });
      } else {
        installInProgress = false;
        deferred.reject(installerErrors.INSTALLED);
      }
    }

    return deferred.promise;
  };
};

module.exports = exports['default'];